import React, { Component } from 'react';
import { Row, Col, Button, Label } from 'reactstrap';
import _ from 'underscore';
import PropTypes from 'prop-types';
import Icon from '../../common/containers/icon';
import JobCoatingThicknessItem from './jobCoatingThicknessItem';
import MultiOtherPicker from '../../common/controls/multiOtherPicker';
import NumberInput from '../../common/controls/numberInput';
import SegmentedPicker from '../../common/controls/segmentedPicker';
const convert = millsValue => millsValue ? millsValue * 25.4 : millsValue;

/* eslint-disable-next-line default-param-last */
function getEntityList(enabled, regular = [], other) {
  if (!enabled) {
    return [];
  }
  let otherAsObject = null;
  if (other) {
    otherAsObject = {
      id: other,
      name: other
    };
  }
  return regular.concat(otherAsObject || []);
}
export default class JobContractRequirementsItem extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.getCurrentThicknessesUnits = this.getCurrentThicknessesUnits.bind(this);
    this.handleAddThickness = this.handleAddThickness.bind(this);
    this.handleEnabledChange = this.handleEnabledChange.bind(this);
    this.handleChangeThicknesses = this.handleChangeThicknesses.bind(this);
    this.handleRemoveThicknesses = this.handleRemoveThicknesses.bind(this);
    this.handleChangeJobSpecification = this.handleChange.bind(this, 'jobSpecifications');
    this.handleChangeASTM = this.handleMultiOtherChange.bind(this, 'astm');
    this.handleChangeAWWA = this.handleChange.bind(null, 'awwa');
    this.handleChangeCustomRequirement = this.handleMultiOtherChange.bind(this, 'customRequirement');
    this.handleChangeISO = this.handleMultiOtherChange.bind(this, 'iso');
    this.handleChangeMilProfileMeans = this.handleMultiOtherChange.bind(this, 'profileMeans');
    this.handleChangeNACE = this.handleMultiOtherChange.bind(this, 'nace');
    this.handleChangeSSPC = this.handleMultiOtherChange.bind(this, 'sspc');
    this.handleChangeSurfaceProfileLow = this.handleSurfaceProfileChange.bind(this, 'surfaceProfileLow');
    this.handleChangeSurfaceProfileHigh = this.handleSurfaceProfileChange.bind(this, 'surfaceProfileHigh');
    this.handleChangeSurfaceProfileUnits = this.handleChange.bind(this, 'surfaceProfileUnits');
    this.handleEnabledChangeSSPC = this.handleEnabledChange.bind(this, 'sspcEnabled', 'sspc', 'sspcOther');
    this.handleEnabledChangeNACE = this.handleEnabledChange.bind(this, 'naceEnabled', 'nace', 'naceOther');
    this.handleEnabledChangeASTM = this.handleEnabledChange.bind(this, 'astmEnabled', 'astm', 'astmOther');
    this.handleEnabledChangeISO = this.handleEnabledChange.bind(this, 'iso8501Enabled', 'iso', 'iso8501Other');
    this.handleEnabledChangeCustomRequirement = this.handleEnabledChange.bind(this, 'customRequirementEnabled', 'customRequirement', 'customRequirementOther');
    this.handleSpecifiedThicknessUnitsChange = this.handleSpecifiedThicknessUnitsChange.bind(this);
  }
  getCurrentThicknessesUnits() {
    const {
      data: {
        thicknesses
      }
    } = this.props;
    return thicknesses && thicknesses[0] ? thicknesses[0].specifiedThicknessUnits : 0;
  }
  handleAddThickness() {
    const {
      data: {
        id
      },
      index,
      onAdd
    } = this.props;
    const defaultData = {
      contractRequirementsID: id,
      specifiedThicknessUnits: this.getCurrentThicknessesUnits()
    };
    onAdd(index, 'thicknesses', defaultData);
  }
  handleSurfaceProfileChange(name, value) {
    const {
      data: {
        surfaceProfileUnits
      }
    } = this.props;
    const result = surfaceProfileUnits && value ? value / 25.4 : value;
    this.handleChange(name, result);
  }
  handleChange(name, value) {
    const {
      onChange,
      index
    } = this.props;
    const path = `${index}/${name}`;
    onChange(path, value);
  }
  handleChangeThicknesses(path, value) {
    const {
      onChange,
      index
    } = this.props;
    // The value here is whatever the current thickeness units are
    let safeValue = value;
    if (path.endsWith('High') || path.endsWith('Low')) {
      safeValue = this.getCurrentThicknessesUnits() ? safeValue / 25.4 : safeValue;
    }
    const contentPath = `${index}/thicknesses/${path}`;
    onChange(contentPath, safeValue);
  }
  handleMultiOtherChange(name, vals) {
    const newValues = (vals || []).filter(val => val && val.identifier);
    const otherValues = (vals || []).filter(val => val && !_.has(val, 'identifier'));
    this.handleChange(name, newValues);

    // handle other
    let otherValue = null;
    let otherName = `${name}Other`;
    if (otherValues.length > 0) {
      // 'iso' is misnamed in server/models/job, should be ISO8501 to match the table
      // https://www.pivotaltracker.com/story/show/156476753
      if (name === 'iso') {
        otherName = `${name}8501Other`;
      } else if (name === 'profileMeans') {
        otherName = 'milProfileMeansOther';
      }

      // only set one other, choosing the last other value.
      otherValue = otherValues[otherValues.length - 1].name;
    }
    this.handleChange(otherName, otherValue);
  }
  handleRemove() {
    const {
      onRemove,
      index
    } = this.props;
    onRemove(index);
  }
  handleRemoveThicknesses(childIndex) {
    const {
      onRemove,
      index
    } = this.props;
    onRemove(index, 'thicknesses', childIndex);
  }

  /** ********************************
   * Private methods
   */

  handleSpecifiedThicknessUnitsChange(newSpecifiedThicknessUnit) {
    const {
      data: {
        thicknesses
      },
      index,
      onChange
    } = this.props;
    thicknesses.forEach((thickness, thickIndex) => {
      const path = `${thickIndex}/specifiedThicknessUnits`;
      onChange(`${index}/thicknesses/${path}`, newSpecifiedThicknessUnit);
    });
  }
  handleEnabledChange(enableKey, collectionKey, otherKey, value) {
    this.handleChange(enableKey, value);
    if (value !== 1) {
      if (collectionKey) {
        this.handleChange(collectionKey, []);
      }
      if (otherKey) {
        this.handleChange(otherKey, null);
      }
    }
  }
  render() {
    const {
      data,
      index,
      sspcList,
      naceList,
      astmList,
      iso8501List,
      customRequirementList,
      milProfileMeansList
    } = this.props;
    const jobCoatingThicknessUnits = this.getCurrentThicknessesUnits();
    const jobCoatingThickness = (data.thicknesses || []).map((thickness, thickIndex) => /*#__PURE__*/React.createElement(JobCoatingThicknessItem, {
      data: thickness,
      index: thickIndex,
      key: thickness.id,
      specifiedThicknessUnits: jobCoatingThicknessUnits,
      onChange: this.handleChangeThicknesses,
      onRemove: this.handleRemoveThicknesses
    }));
    let low = data.surfaceProfileLow;
    let high = data.surfaceProfileHigh;
    if (data.surfaceProfileUnits) {
      low = convert(low);
      high = convert(high);
    }
    low = low ? +low.toFixed(2) : low;
    high = high ? +high.toFixed(2) : high;
    const coatingThickness = data.thicknesses ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, {
      className: "t-jcr-coating-thickness"
    }, /*#__PURE__*/React.createElement(Col, {
      sm: {
        size: 3,
        offset: 9
      }
    }, /*#__PURE__*/React.createElement(SegmentedPicker, {
      label: "Units",
      names: ['Mils', 'Microns'],
      values: [0, 1],
      allowNull: false,
      onChange: this.handleSpecifiedThicknessUnitsChange,
      value: jobCoatingThicknessUnits
    }))), jobCoatingThickness) : null;
    return /*#__PURE__*/React.createElement("section", {
      className: `t-jcr-${index}`
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 2
    }, /*#__PURE__*/React.createElement(SegmentedPicker, {
      label: "Job Specs Only",
      names: ['Yes', 'No'],
      values: [1, 0],
      onChange: this.handleChangeJobSpecification,
      value: data.jobSpecifications
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 2
    }, /*#__PURE__*/React.createElement(SegmentedPicker, {
      label: "SSPC",
      names: ['Yes', 'No'],
      values: [1, 0],
      onChange: this.handleEnabledChangeSSPC,
      value: data.sspcEnabled
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 10
    }, /*#__PURE__*/React.createElement(MultiOtherPicker, {
      disabled: !data.sspcEnabled,
      disabledText: "Turn on SSPC to enable ...",
      label: "Applicable SSPC Standards",
      maxTextLength: 100,
      onChange: this.handleChangeSSPC,
      options: sspcList,
      placeholder: "Select...",
      values: getEntityList(data.sspcEnabled, data.sspc, data.sspcOther)
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 2
    }, /*#__PURE__*/React.createElement(SegmentedPicker, {
      label: "NACE",
      names: ['Yes', 'No'],
      values: [1, 0],
      onChange: this.handleEnabledChangeNACE,
      value: data.naceEnabled
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 10
    }, /*#__PURE__*/React.createElement(MultiOtherPicker, {
      disabled: !data.naceEnabled,
      disabledText: "Turn on NACE to enable ...",
      label: "Applicable NACE Standards",
      maxTextLength: 100,
      options: naceList,
      values: getEntityList(data.naceEnabled, data.nace, data.naceOther),
      placeholder: "Select...",
      onChange: this.handleChangeNACE
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 2
    }, /*#__PURE__*/React.createElement(SegmentedPicker, {
      label: "ASTM",
      names: ['Yes', 'No'],
      values: [1, 0],
      onChange: this.handleEnabledChangeASTM,
      value: data.astmEnabled
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 10
    }, /*#__PURE__*/React.createElement(MultiOtherPicker, {
      disabled: !data.astmEnabled,
      disabledText: "Turn on ASTM to enable ...",
      label: "ASTM Standards",
      options: astmList,
      values: getEntityList(data.astmEnabled, data.astm, data.astmOther),
      placeholder: "Select...",
      onChange: this.handleChangeASTM
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 2
    }, /*#__PURE__*/React.createElement(SegmentedPicker, {
      label: "ISO",
      names: ['Yes', 'No'],
      values: [1, 0],
      onChange: this.handleEnabledChangeISO,
      value: data.iso8501Enabled
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 10
    }, /*#__PURE__*/React.createElement(MultiOtherPicker, {
      disabled: !data.iso8501Enabled,
      disabledText: "Turn on ISO to enable ...",
      label: "Applicable ISO Standards",
      maxTextLength: 100,
      options: iso8501List,
      values: getEntityList(data.iso8501Enabled, data.iso, data.iso8501Other),
      placeholder: "Select...",
      onChange: this.handleChangeISO
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 2
    }, /*#__PURE__*/React.createElement(SegmentedPicker, {
      label: "AWWA",
      names: ['Yes', 'No'],
      values: [1, 0],
      onChange: this.handleChangeAWWA,
      value: data.awwa
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 2
    }, /*#__PURE__*/React.createElement(SegmentedPicker, {
      label: "Other",
      names: ['Yes', 'No'],
      values: [1, 0],
      name: "customRequirementControl",
      onChange: this.handleEnabledChangeCustomRequirement,
      value: data.customRequirementEnabled
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 10
    }, /*#__PURE__*/React.createElement(MultiOtherPicker, {
      disabled: !data.customRequirementEnabled,
      disabledText: "Turn on Other to enable ...",
      label: "Other Standards",
      options: customRequirementList,
      values: getEntityList(data.customRequirementEnabled, data.customRequirement, data.customRequirementOther),
      placeholder: "Select...",
      onChange: this.handleChangeCustomRequirement
    }))), /*#__PURE__*/React.createElement(Row, {
      className: "t-jcr-profile"
    }, /*#__PURE__*/React.createElement(Col, {
      sm: 4
    }, /*#__PURE__*/React.createElement(Label, null, "Specified Surface Profile"), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement(NumberInput, {
      name: "surfaceProfileLow",
      placeholder: "Low",
      entity: "ContractRequirements",
      field: "surfaceProfileLow",
      onChange: this.handleChangeSurfaceProfileLow,
      value: low
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement(NumberInput, {
      name: "surfaceProfileHigh",
      placeholder: "High",
      entity: "ContractRequirements",
      field: "surfaceProfileHigh",
      onChange: this.handleChangeSurfaceProfileHigh,
      value: high
    })))), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(SegmentedPicker, {
      label: "Units",
      names: ['Mils', 'Microns'],
      values: [0, 1],
      allowNull: false,
      onChange: this.handleChangeSurfaceProfileUnits,
      value: data.surfaceProfileUnits
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 12
    }, /*#__PURE__*/React.createElement(MultiOtherPicker, {
      label: "Profile Accomplished By",
      options: milProfileMeansList,
      values: getEntityList(true, data.profileMeans, data.milProfileMeansOther),
      placeholder: "Select...",
      onChange: this.handleChangeMilProfileMeans
    }))), /*#__PURE__*/React.createElement("h3", null, "Specified Coating Thickness Range Required"), coatingThickness, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: {
        size: 2,
        offset: 10
      }
    }, /*#__PURE__*/React.createElement(Button, {
      size: "sm",
      className: "form-control t-jcr-add tqc-control",
      onClick: this.handleAddThickness
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "plus"
    }), " Add Entry"))));
  }
}
JobContractRequirementsItem.propTypes = {
  astmList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  customRequirementList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  data: PropTypes.shape({
    astm: PropTypes.arrayOf(PropTypes.shape({})),
    astmOther: PropTypes.string,
    astmEnabled: PropTypes.number,
    awwa: PropTypes.number,
    customRequirementEnabled: PropTypes.number,
    customRequirement: PropTypes.arrayOf(PropTypes.shape({})),
    customRequirementOther: PropTypes.string,
    id: PropTypes.string.isRequired,
    iso8501Other: PropTypes.string,
    iso: PropTypes.arrayOf(PropTypes.shape({})),
    iso8501Enabled: PropTypes.number,
    jobSpecifications: PropTypes.number,
    milProfileMeansOther: PropTypes.string,
    nace: PropTypes.arrayOf(PropTypes.shape({})),
    naceOther: PropTypes.string,
    naceEnabled: PropTypes.number,
    profileMeans: PropTypes.arrayOf(PropTypes.shape({})),
    sspc: PropTypes.arrayOf(PropTypes.shape({})),
    sspcOther: PropTypes.string,
    sspcEnabled: PropTypes.number,
    surfaceProfileUnits: PropTypes.number,
    surfaceProfileHigh: PropTypes.number,
    surfaceProfileLow: PropTypes.number,
    thicknesses: PropTypes.arrayOf(PropTypes.shape({
      specifiedThicknessUnits: PropTypes.number
    }))
  }).isRequired,
  index: PropTypes.number.isRequired,
  iso8501List: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  naceList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  milProfileMeansList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  sspcList: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};